<h1 *ngIf="!_originData" style="text-align: center; margin-top: 100px;">{{ feedbackMessage }}</h1>

<div *ngIf="isOrderInitiating" class="row justify-content-md-center mt-5 order-submission-loading-container">
  <div *ngIf="!isOrderSubmit" class="col-md-12" style="max-width: 450px;">
    <div class="card">
      <div class="card-body text-center">
        <span class="spinner-border spinner-border-sm cs-loading-spinner" role="status" aria-hidden="true"></span>
        <p class="status-text">{{orderProcessingMessage}}</p>
        <p class="status-text text-muted">The task is being executed. Please wait until it is completed.</p>
      </div>
    </div>
  </div>
  <div *ngIf="isOrderSubmit" class="col-md-12" style="max-width: 500px;">
    <div class="card submition-detail">
      <div class="card-body">
        <div class="row" *ngIf="transactionStatus">
          <div class="col-md-12 text-center mb-2">
            <ng-container *ngIf="transactionStatus.status.trim() === ''; else viewTransactionStatusFormElse"
                          class="material-icons text-danger success-icon">cancel</ng-container>
            <ng-template #viewTransactionStatusFormElse>
              <span *ngIf="transactionStatus.status.toLowerCase() === _transactionStatus.Completed || transactionStatus.status.toLowerCase() === 'submitted'"
                    class="material-icons success-icon">check_circle</span>
              <span *ngIf="transactionStatus.status.toLowerCase() === _transactionStatus.Pending"
                    class="material-icons text-black-50 success-icon">pending</span>
              <span *ngIf="transactionStatus.status.toLowerCase() === _transactionStatus.Failed"
                    class="material-icons text-danger success-icon">cancel</span>
              <span *ngIf="transactionStatus.status.toLowerCase() === _transactionStatus.Processing"
                    class="material-icons text-black-50 success-icon">change_circle</span>
            </ng-template>
            <p class="status-text">{{orderProcessingMessage}}</p>
          </div>
          <div class="col-md-12">
            <!-- <p class="order-submit-success-detail-text mb-0">Order # <span>{{transactionStatus.orderNumber}}</span></p> -->
            <p class="order-submit-success-detail-text mb-0">
              Order Action <span>{{transactionStatus.orderAction}}</span>
            </p>
            <p class="order-submit-success-detail-text mb-0">Order Type <span>{{transactionStatus.orderType}}</span></p>
            <p class="order-submit-success-detail-text mb-0">
              Requested By <span>{{transactionStatus.requestedBy}}</span>
            </p>
            <p class="order-submit-success-detail-text mb-0">
              Requested On <span>
                {{
transactionStatus.createdDate | date:
                'short'
                }}
              </span>
            </p>
            <p class="order-submit-success-detail-text mb-0">
              Updated Date <span>
                {{
transactionStatus.updatedDate | date:
                'short'
                }}
              </span>
            </p>
            <p class="order-submit-success-detail-text mb-3 border-bottom">
              Transaction ID
              <span>{{transactionStatus.transactionId}}</span>
            </p>
            <p *ngIf="transactionStatus.message.trim() !==''"
               class="order-submit-success-detail-text text-danger text-center mb-3">{{transactionStatus.message}}</p>
          </div>
          <div class="col-md-12 mt-3">
            <button type="button" class="btn btn-primary w-100" [disabled]="isProcessDoneLoading"
                    (click)="onProcessDoneButtonClick()" style="padding: 7px; font-size: 1.1rem;">
              <span *ngIf="!isProcessDoneLoading" class="material-icons">check</span>
              <span *ngIf="isProcessDoneLoading" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
              {{ isProcessDoneLoading ? 'Loading...' : 'Done' }}
            </button>
          </div>
          <div class="col-md-12 mt-3">
            <button type="button" class="btn btn-primary w-100" [disabled]="isProcessViewOrderLoading"
                    (click)="onProcessViewDetailOrderButtonClick()" style="padding: 7px; font-size: 1.1rem;">
              <span *ngIf="!isProcessViewOrderLoading" class="material-icons">send</span>
              <span *ngIf="isProcessViewOrderLoading" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
              {{ isProcessViewOrderLoading ? 'Loading...' : 'New Order' }}
            </button>
          </div>
          <div class="col-md-12 mt-3">
            <button type="button" class="btn btn-primary w-100" [disabled]="isProcessViewDocumentUploadLoading"
                    (click)="onProcessViewDetailDocumentUploadButtonClick()" style="padding: 7px; font-size: 1.1rem;">
              <span *ngIf="!isProcessViewDocumentUploadLoading" class="material-icons">assignment</span>
              <span *ngIf="isProcessViewDocumentUploadLoading" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
              {{ isProcessViewDocumentUploadLoading ? 'Loading...' : 'Document Upload' }}
            </button>
          </div>
          <!--<div class="col-md-12 mt-3">
            <button type="button" class="btn btn-primary w-100" (click)="checkRequiredFields()" style="padding: 7px; font-size: 1.1rem;">
              <span class="material-icons">assignment</span> Check Validations
            </button>
          </div>-->
        </div>

      </div>
    </div>
  </div>
</div>

<div class="custom-container" *ngIf="_originData && !isOrderInitiating">

  <!--<div class="sub-header">
      <div class="row">
        <div class="col-lg-6">
          <h4>Home</h4>
        </div>
        <div class="col-lg-6 text-right">

        </div>
      </div>
    </div>
    <hr class="custom-hr" />
         <div class="row justify-content-md-center mt-3">
       <div class="col-md-12">

         <div class="card shadow">
           <div class="card-body">

             <div class="row">
               <button type="button" class="btn btn-secondary" data-dismiss="modal"><span class="material-icons">close</span> Close</button>
                 <div class="col-lg-8 col-md-8 col-sm-8 mb-4 ml-2">
                 <div class="custom-control custom-switch custom-switch-md mt-2">
                   <span class="custom-active-label">Print to efolder</span>
                   <input type="checkbox"
                          class="custom-control-input"
                          id="customSwitchPrintToeFolder"
                          [checked]="isPrintToeFolder"
                          (change)="onPrintToeFolderChange($event)">
                   <label class="custom-control-label" for="customSwitchPrintToeFolder"></label>
                 </div>
               </div>
             </div>

           </div>
         </div>

       </div>
     </div>

        <mat-stepper #stepper>
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel>Fill out your name</ng-template>
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
          </mat-form-field>
          <div>
            <button mat-button matStepperNext>Next</button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup" label="Fill out your address">
        <form [formGroup]="secondFormGroup">
          <mat-form-field>
            <mat-label>Address</mat-label>
            <input matInput formControlName="secondCtrl" placeholder="Ex. 1 Main St, New York, NY"
                   required>
          </mat-form-field>
          <div>
            <button mat-button matStepperPrevious>Back</button>
            <button mat-button matStepperNext>Next</button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Done</ng-template>
        <p>You are now done.</p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button (click)="stepper.reset()">Reset</button>
        </div>
      </mat-step>
    </mat-stepper>

      <div class="col-lg-12 col-md-12 col-sm-12">
    <button type="submit" class="btn btn-primary" [disabled]="isLoading" style="width: 100%; margin-top: 18px;">
      <span *ngIf="!isLoading" class="material-icons">search</span>
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      {{ isLoading ? 'Searching...' : 'Search' }}
    </button>
  </div>
      -->


  <form class="example-form" [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit()">
    <div *ngIf="false" class="form-content login-form-content">

      <div class="row justify-content-md-center mb-3">
        <div class="col-lg-12 col-md-12 col-sm-12" style="max-width: 500px;">

          <div class="card shadow">
            <div class="card-header">Login Information</div>
            <div class="card-body">

              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <mat-label>User Id</mat-label>
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="" formControlName="userId">
                    <mat-error *ngIf="loginForm.get('userId')?.invalid && loginForm.get('userId')?.touched">
                      {{ getErrorMessage(loginForm.get('userId')) }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <mat-label>Password</mat-label>
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="" formControlName="password" type="password">
                    <mat-error *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                      {{ getErrorMessage(loginForm.get('password')) }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top: 20px;">
                  <mat-checkbox formControlName="isSaveLoginInformation"
                                (change)="onSaveLoginInformationCheckboxChange($event)" class="mat-check-position-top">
                    Save login
                    Information
                  </mat-checkbox>
                  <mat-error *ngIf="loginForm.get('isSaveLoginInformation')?.invalid && loginForm.get('isSaveLoginInformation')?.touched">{{getErrorMessage(loginForm.get('isSaveLoginInformation'))}}</mat-error>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12" style="">
                  <button type="submit" class="btn btn-primary">
                    <span class="material-icons">login</span>
                    Connect
                  </button>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>

  </form>

  <form class="example-form" [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit()">
    <div class="form-content">

      <div *ngIf="false" class="row justify-content-md-center">
        <div class="col-lg-12 col-md-12 col-sm-12" style="max-width: 975px; ">

          <div class="card">
            <div class="card-header">Login Information</div>
            <div class="card-body">

              <div class="row">
                <div class="col col-lg-4 col-md-4 col-sm-4" style="max-width: 300px;">
                  <mat-label>User Id</mat-label>
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="" formControlName="userId">
                    <mat-error *ngIf="loginForm.get('userId')?.invalid && loginForm.get('userId')?.touched">
                      {{ getErrorMessage(loginForm.get('userId')) }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col col-lg-4 col-md-4 col-sm-4" style="max-width: 300px;">
                  <mat-label>Password</mat-label>
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="" formControlName="password" type="password">
                    <mat-error *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                      {{ getErrorMessage(loginForm.get('password')) }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col col-lg-3 col-md-3 col-sm-3" style="max-width: 175px; padding-top: 20px;">
                  <mat-checkbox formControlName="isSaveLoginInformation"
                                (change)="onSaveLoginInformationCheckboxChange($event)" class="mat-check-position-top">
                    Save login
                    Information
                  </mat-checkbox>
                  <mat-error *ngIf="loginForm.get('isSaveLoginInformation')?.invalid && loginForm.get('isSaveLoginInformation')?.touched">{{getErrorMessage(loginForm.get('isSaveLoginInformation'))}}</mat-error>
                </div>
                <div class="col col-lg-1 col-md-1 col-sm-1" style="min-width: 130px; padding-top: 18px;">
                  <button type="submit" class="btn btn-primary">
                    <span class="material-icons">login</span>
                    Connect
                  </button>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>

  </form>

  <form class="example-form" [formGroup]="LoanDataForm" (ngSubmit)="onLoanFormSubmit()">
    <div class="form-content">
      <div class="row justify-content-md-center">
        <div class="col-md-12" style="max-width: 1060px;">

          <div class="card" style="padding: 3px 20px 0px">
            <!--<div class="card-header">Loan Data</div>-->
            <div class="card-body loan-data-card-body">

              <div class="row">
                <div class="col col-lg-2 col-md-2 col-sm-2">
                  <mat-label>Loan Number</mat-label>
                  <p class="loan-data-values">{{LoanDataForm.get('loanNumber')?.value}}</p>
                  <mat-form-field class="example-full-width" *ngIf="false">
                    <input matInput placeholder="" formControlName="loanNumber">
                    <mat-error *ngIf="LoanDataForm.get('loanNumber')?.invalid && LoanDataForm.get('loanNumber')?.touched">
                      {{ getErrorMessage(LoanDataForm.get('loanNumber')) }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col col-lg-2 col-md-2 col-sm-2">
                  <mat-label>Borrower</mat-label>
                  <p class="loan-data-values">{{LoanDataForm.get('borrower')?.value}}</p>
                  <mat-form-field class="example-full-width" *ngIf="false">
                    <input matInput placeholder="" formControlName="borrower">
                    <mat-error *ngIf="LoanDataForm.get('borrower')?.invalid && LoanDataForm.get('borrower')?.touched">
                      {{ getErrorMessage(LoanDataForm.get('borrower')) }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col col-lg-2 col-md-2 col-sm-2">
                  <mat-label>Loan Purpose</mat-label>
                  <p class="loan-data-values">{{LoanDataForm.get('loanPurpose')?.value}}</p>
                  <mat-form-field class="example-full-width" *ngIf="false">
                    <mat-select formControlName="loanPurpose">
                      <mat-option *ngFor="let option of loanPurposeList" [value]="option.key">
                        {{
 option.value
                        }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="LoanDataForm.get('loanPurpose')?.invalid && LoanDataForm.get('loanPurpose')?.touched">
                      {{getErrorMessage(LoanDataForm.get('loanPurpose'))}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col col-lg-2 col-md-2 col-sm-2">
                  <mat-label>Loan Type</mat-label>
                  <p class="loan-data-values">{{LoanDataForm.get('loanType')?.value}}</p>
                  <mat-form-field class="example-full-width" *ngIf="false">
                    <mat-select formControlName="loanType">
                      <mat-option *ngFor="let option of loanTypeList" [value]="option.value">
                        {{
 option.value
                        }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="LoanDataForm.get('loanType')?.invalid && LoanDataForm.get('loanType')?.touched">
                      {{getErrorMessage(LoanDataForm.get('loanType'))}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col col-lg-4 col-md-4 col-sm-4">
                  <mat-label>Property Address</mat-label>
                  <p class="loan-data-values">{{LoanDataForm.get('propertyAddress')?.value}}</p>
                  <mat-form-field class="example-full-width" *ngIf="false">
                    <input matInput placeholder="" formControlName="propertyAddress">
                    <mat-error *ngIf="LoanDataForm.get('propertyAddress')?.invalid && LoanDataForm.get('propertyAddress')?.touched">
                      {{ getErrorMessage(LoanDataForm.get('propertyAddress')) }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </form>

  <div class="row justify-content-md-center mt-2">
    <div class="col-md-12" style="max-width: 1060px;">
      <div class="card pt-2">

        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link active" id="pills-group-tab" data-toggle="pill" href="#pills-group" role="tab"
               aria-controls="pills-group" aria-selected="true" (click)="onTabChange('titleFees')">
              <span class="material-icons">playlist_add_check</span> Title Fees
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="pills-fields-tab" data-toggle="pill" href="#pills-fields" role="tab"
               aria-controls="pills-fields" aria-selected="false" (click)="onTabChange('order')">
              <div class="material-icons">receipt_long</div> Title Order
            </a>
          </li>
          <!--<li class="nav-item" role="presentation">
            <a class="nav-link" id="pills-order-status-tab" data-toggle="pill" href="#pills-order-status" role="tab" aria-controls="pills-order-status" aria-selected="false" (click)="onTabChange('orderStatus')"><span class="material-icons">list_alt</span> Order & Title Status</a>
          </li>-->
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="pills-report-test-tab" data-toggle="pill" href="#pills-report-test" role="tab"
               aria-controls="pills-report-test" aria-selected="false" (click)="onTabChange('uploadDocuments')">
              <span class="material-icons">upload</span> Documents
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="pills-test1-tab" data-toggle="pill" href="#pills-test1" role="tab"
               aria-controls="pills-test1" aria-selected="false" (click)="onTabChange('downloadDocuments')">
              <span class="material-icons">download</span> Documents
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="pills-test2-tab" data-toggle="pill" href="#pills-test2" role="tab"
               aria-controls="pills-test2" aria-selected="false" (click)="onTabChange('payOffs')">
              <span class="material-icons">payments</span> Payoffs
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="pills-test3-tab" data-toggle="pill" href="#pills-test3" role="tab"
               aria-controls="pills-test3" aria-selected="false" (click)="onTabChange('verifications')">
              <span class="material-icons">verified</span> Verifications
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="pills-test4-tab" data-toggle="pill" href="#pills-test4" role="tab"
               aria-controls="pills-test4" aria-selected="false" (click)="onTabChange('schedule')">
              <span class="material-icons">schedule</span> Schedule Mobile Notary
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="pills-test5-tab" data-toggle="pill" href="#pills-test5" role="tab"
               aria-controls="pills-test5" aria-selected="false" (click)="onTabChange('email')">
              <span class="material-icons">email</span> Email Your Team
            </a>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <form *ngIf="activeTab !== 'orderStatus'" class="example-form" [formGroup]="commonForm"
                (ngSubmit)="onTitleOrderFormSubmit()">
            <div class="card-header">Unisource Data</div>
            <div class="card-body">
              <div class="row common-form-controls">
                <div class="col col-lg-4 col-md-4 col-sm-4" *ngIf="activeTab !== 'titleFees'">
                  <mat-label>Title Order #</mat-label>
                  <mat-form-field class="example-full-width">
                    <mat-select formControlName="titleOrder" (selectionChange)="onOrdersChange($event)">
                      <mat-option *ngFor="let option of _orders" [value]="option.orderId">
                        {{ option.orderNumber }} -
                        [{{option.status}}]
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="commonForm.get('titleOrder')?.invalid && commonForm.get('titleOrder')?.touched">
                      {{getErrorMessage(commonForm.get('titleOrder'))}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col col-lg-4 col-md-4 col-sm-4" *ngIf="activeTab === 'order' || activeTab === 'titleFees'">
                  <mat-label>Primary Contact</mat-label>
                  <mat-form-field class="example-full-width">
                    <mat-select formControlName="primaryContact">
                      <mat-option *ngFor="let option of primaryContactList" [value]="option.email">
                        {{
 option.firstName
                        }} {{ option.lastName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="commonForm.get('primaryContact')?.invalid && commonForm.get('primaryContact')?.touched">
                      {{getErrorMessage(commonForm.get('primaryContact'))}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col col-lg-4 col-md-4 col-sm-4"
                     *ngIf="transactionId.trim() !== '' && activeTab !== 'titleFees' && commonForm.get('titleOrder')?.value !==''">
                  <mat-label>Transaction Id</mat-label>
                  <p class="transaction-id-tag">{{transactionId}}</p>
                </div>
                <!-- <div class="col-lg-2">
                  <button type="button" class="btn btn-primary" (click)="opensessionDialog()">openSessionExpiredModal</button>
                </div> -->

              </div>
            </div>
          </form>
          <div class="tab-pane" id="pills-fields" role="tabpanel" aria-labelledby="pills-fields-tab">
            <ng-container *ngTemplateOutlet="fieldsTabTemplate"></ng-container>
          </div>
          <div class="tab-pane active show" id="pills-group" role="tabpanel" aria-labelledby="pills-group-tab">
            <ng-container *ngTemplateOutlet="groupTabTemplate"></ng-container>
          </div>
          <div class="tab-pane" id="pills-order-status" role="tabpanel" aria-labelledby="pills-order-status-tab">
            <ng-container *ngTemplateOutlet="orderStatusTemplate"></ng-container>
          </div>
          <div class="tab-pane" id="pills-report-test" role="tabpanel" aria-labelledby="pills-report-test-tab">
            <ng-container *ngTemplateOutlet="testTabTemplate"></ng-container>
          </div>
          <div class="tab-pane" id="pills-test1" role="tabpanel" aria-labelledby="pills-test1-tab">
            <ng-container *ngTemplateOutlet="test1TabTemplate"></ng-container>
          </div>
          <div class="tab-pane" id="pills-test2" role="tabpanel" aria-labelledby="pills-test2-tab">
            <ng-container *ngTemplateOutlet="test2TabTemplate"></ng-container>
          </div>
          <div class="tab-pane" id="pills-test3" role="tabpanel" aria-labelledby="pills-test3-tab">
            <ng-container *ngTemplateOutlet="test3TabTemplate"></ng-container>
          </div>
          <div class="tab-pane" id="pills-test4" role="tabpanel" aria-labelledby="pills-test4-tab">
            <ng-container *ngTemplateOutlet="test4TabTemplate"></ng-container>
          </div>
          <div class="tab-pane" id="pills-test5" role="tabpanel" aria-labelledby="pills-test5-tab">
            <ng-container *ngTemplateOutlet="test5TabTemplate"></ng-container>
          </div>
        </div>

      </div>
    </div>
  </div>

  <ng-template #fieldsTabTemplate>
    <form class="example-form" [formGroup]="titleOrderForm" (ngSubmit)="confirmationOrder()">
      <div class="form-content">
        <div class="row justify-content-md-center">
          <div class="col-md-12">

            <div class="">
              <div class="card-header">
                Title Order
                <!-- <button *ngIf="activeTab === 'order'" type="button"
                  class="btn btn-outline-warning btn-history float-right" (click)="getOrderHistory()"><span
                    class="material-icons">history</span> View History</button> -->
              </div>
              <div class="card-body">

                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-8">

                    <div class="row">
                      <div class="col col-lg-12 mb-3"><h2>Transaction Information</h2></div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Transaction Type</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="transactionType"
                                      (selectionChange)="onOrderTransactionTypeChange($event)">
                            <mat-option *ngFor="let option of transactionTypeList" [value]="option">
                              {{
 option.name
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="titleOrderForm.get('transactionType')?.invalid && titleOrderForm.get('transactionType')?.touched">
                            {{getErrorMessage(titleOrderForm.get('transactionType'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Product / Services</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="productServices">
                            <mat-option *ngFor="let option of productServiceList" [value]="option">
                              {{
 option.name
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="titleOrderForm.get('productServices')?.invalid && titleOrderForm.get('productServices')?.touched">
                            {{getErrorMessage(titleOrderForm.get('productServices'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Loan Amount</mat-label>
                        <mat-form-field class="example-full-width">
                          <span matPrefix>$</span>
                          <input matInput placeholder="" formControlName="loanAmount" type="number">
                          <mat-error *ngIf="titleOrderForm.get('loanAmount')?.invalid && titleOrderForm.get('loanAmount')?.touched">
                            {{ getErrorMessage(titleOrderForm.get('loanAmount')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Sales Price</mat-label>
                        <mat-form-field class="example-full-width">
                          <span matPrefix>$</span>
                          <input matInput placeholder="" formControlName="salesPrice" type="number">
                          <mat-error *ngIf="titleOrderForm.get('salesPrice')?.invalid && titleOrderForm.get('salesPrice')?.touched">
                            {{ getErrorMessage(titleOrderForm.get('salesPrice')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>

                    </div>

                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="row">
                      <div class="col col-lg-12 col-md-12 col-sm-12">
                        <mat-label>Comments</mat-label>
                        <mat-form-field class="example-full-width">
                          <textarea matInput formControlName="comments" rows="5"></textarea>
                          <mat-error *ngIf="titleOrderForm.get('comments')?.invalid && titleOrderForm.get('comments')?.touched">
                            {{ getErrorMessage(titleOrderForm.get('comments')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col col-lg-12 col-md-12 col-sm-12 text-right" style="">
                    <button type="button" class="btn btn-outline-secondary float-left" (click)="getOrderHistory()">
                      <span class="material-icons">history</span> View History
                    </button>
                    <button type="submit" *ngIf="!_unisourceData.isRestrictedUser" class="btn btn-primary"
                            style="width: 225px;">
                      <span class="material-icons">send</span> New Order
                    </button>
                  </div>

                  <!-- <div class="col col-lg-4 col-md-4 col-sm-6" *ngIf="payOffQuestionsFlag">
                    <div class="question-section">
                      <div class="row">
                        <div class="col-lg-12">
                          <mat-label>a. What is the high amount for the last mortgage being paid off ?</mat-label>
                          <mat-form-field class="example-full-width">
                            <input matInput placeholder="" formControlName="consideration" type="number">
                            <mat-error
                              *ngIf="titleOrderForm.get('consideration')?.invalid && titleOrderForm.get('consideration')?.touched">
                              {{ getErrorMessage(titleOrderForm.get('consideration')) }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-lg-12 mb-4">
                          <mat-label>b. What is the date of the last mortgage ?</mat-label>
                          <input matInput type="datetime-local" formControlName="policyDate"
                            class="custom-date-time-picker">
                          <mat-error
                            *ngIf="titleOrderForm.get('policyDate')?.invalid && titleOrderForm.get('policyDate')?.touched">{{getErrorMessage(titleOrderForm.get('policyDate'))}}</mat-error>
                        </div>
                        <div class="col-lg-12">
                          <mat-label>c. What is the current balance of pay off the mortgage ?</mat-label>
                          <mat-form-field class="example-full-width">
                            <input matInput placeholder="" formControlName="amount" type="number">
                            <mat-error
                              *ngIf="titleOrderForm.get('amount')?.invalid && titleOrderForm.get('amount')?.touched">
                              {{ getErrorMessage(titleOrderForm.get('amount')) }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col col-lg-4 col-md-4 col-sm-6" *ngIf="policyQuetionsFlag">
                    <div class="question-section">
                      <div class="row">
                        <div class="col-lg-12 mb-4">
                          <mat-label>a. Prior Policy Date</mat-label>
                          <input matInput type="datetime-local" formControlName="policyDate"
                            class="custom-date-time-picker">
                          <mat-error
                            *ngIf="titleOrderForm.get('policyDate')?.invalid && titleOrderForm.get('policyDate')?.touched">{{getErrorMessage(titleOrderForm.get('policyDate'))}}</mat-error>
                        </div>
                        <div class="col-lg-12">
                          <mat-label>b. Prior Policy Coverage Amount</mat-label>
                          <mat-form-field class="example-full-width">
                            <input matInput placeholder="" formControlName="consideration" type="number">
                            <mat-error
                              *ngIf="titleOrderForm.get('consideration')?.invalid && titleOrderForm.get('consideration')?.touched">
                              {{ getErrorMessage(titleOrderForm.get('consideration')) }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>-->

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #orderStatusTemplate>
    <div class="row justify-content-md-center">
      <div class="col-md-12">

        <div class="">
          <div class="card-header">Order & Title Status</div>
          <div class="card-body">

            <div class="row">
              <div class="col col-lg-12 col-md-12 col-sm-12">
                <div class="table-container" style="min-height: 50px; max-height: 300px">
                  <table class="table table-bordered dashboard-transaction-table">
                    <thead>
                      <tr>
                        <th>Order#</th>
                        <th>Transaction#</th>
                        <th>Primary Contact</th>
                        <th>Requested By</th>
                        <th>Requested Date</th>
                        <th>Type</th>
                        <th width="150">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="orderAndTitleStatusList.length === 0">
                        <td colspan="7" class="no-field-added-row">No record found</td>
                      </tr>
                      <tr *ngFor="let item of orderAndTitleStatusList; let i = index">
                        <td>{{item.orderNumber}}</td>
                        <td>{{item.transactionId}}</td>
                        <td>Adeptive Admin</td>
                        <td>{{item.requestedBy}}</td>
                        <td>{{item.createdDate | date: 'short'}}</td>
                        <td>{{item.orderType}}</td>
                        <td>{{item.partnerStatus}}</td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col col-lg-12 col-md-12 col-sm-12 mt-3 text-right">

              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </ng-template>
  <ng-template #groupTabTemplate>
    <form class="example-form" [formGroup]="titleFeesForm" (ngSubmit)="onFeesFormSubmit()">
      <div class="form-content">
        <div class="row justify-content-md-center">
          <div class="col-md-12">

            <div class="">
              <div class="card-header">
                Title Fees
                <!-- <button type="button" class="btn btn-outline-warning btn-history float-right"
                  (click)="getFeesHistory()"><span class="material-icons">history</span> View History</button> -->
              </div>
              <div class="card-body">

                <div class="row">
                  <div class="col col-lg-12 col-md-12 col-sm-12">
                    <div class="row">
                      <div class="col col-lg-12 mb-3"><h2>Transaction Information</h2></div>
                      <div class="col col-lg-4 col-md-4 col-sm-4">
                        <mat-label>Transaction Type</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="transactionType"
                                      (selectionChange)="onFeesTransactionTypeChange($event)">
                            <mat-option *ngFor="let option of transactionTypeList" [value]="option">
                              {{
 option.name
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="titleFeesForm.get('transactionType')?.invalid && titleFeesForm.get('transactionType')?.touched">
                            {{getErrorMessage(titleFeesForm.get('transactionType'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-4 col-md-4 col-sm-4">
                        <mat-label>Product / Services</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="productServices">
                            <mat-option *ngFor="let option of productServiceFeesList" [value]="option">
                              {{
 option.name
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="titleFeesForm.get('productServices')?.invalid && titleFeesForm.get('productServices')?.touched">
                            {{getErrorMessage(titleFeesForm.get('productServices'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-2 col-md-3 col-sm-4">
                        <mat-label>Loan Amount</mat-label>
                        <mat-form-field class="example-full-width">
                          <span matPrefix>$</span>
                          <input matInput placeholder="" formControlName="loanAmount" type="number">
                          <mat-error *ngIf="titleFeesForm.get('loanAmount')?.invalid && titleFeesForm.get('loanAmount')?.touched">
                            {{ getErrorMessage(titleFeesForm.get('loanAmount')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-2 col-md-3 col-sm-4">
                        <mat-label>Sales Price</mat-label>
                        <mat-form-field class="example-full-width">
                          <span matPrefix>$</span>
                          <input matInput placeholder="" formControlName="salesPrice" type="number">
                          <mat-error *ngIf="titleFeesForm.get('salesPrice')?.invalid && titleFeesForm.get('salesPrice')?.touched">
                            {{ getErrorMessage(titleFeesForm.get('salesPrice')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col col-lg-12 mb-3"><h2>Property Address</h2></div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Street Address</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="streetAddress">
                          <mat-error *ngIf="titleFeesForm.get('streetAddress')?.invalid && titleFeesForm.get('streetAddress')?.touched">
                            {{ getErrorMessage(titleFeesForm.get('streetAddress')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-4 col-md-4 col-sm-4">
                        <mat-label>City</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="city">
                          <mat-error *ngIf="titleFeesForm.get('city')?.invalid && titleFeesForm.get('city')?.touched">{{ getErrorMessage(titleFeesForm.get('city')) }}</mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-2 col-md-2 col-sm-4">
                        <mat-label>County</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="county">
                          <mat-error *ngIf="titleFeesForm.get('county')?.invalid && titleFeesForm.get('county')?.touched">{{ getErrorMessage(titleFeesForm.get('county')) }}</mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-3 col-md-3 col-sm-4">
                        <mat-label>State</mat-label>
                         <mat-form-field class="example-full-width">
                          <mat-select formControlName="state">
                            <mat-option *ngFor="let option of stateList" [value]="option.key">{{option.value}}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="titleFeesForm.get('state')?.invalid && titleFeesForm.get('state')?.touched">
                            {{getErrorMessage(titleFeesForm.get('state'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-2 col-md-3 col-sm-4">
                        <mat-label>Zip Code</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="postalCode">
                          <mat-error *ngIf="titleFeesForm.get('postalCode')?.invalid && titleFeesForm.get('postalCode')?.touched">{{ getErrorMessage(titleFeesForm.get('postalCode')) }}</mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col col-lg-7 col-md-12 col-sm-12 text-right" style="padding-top: 13px; margin-bottom: 27px;">
                        <button type="button" class="btn btn-outline-secondary mr-3" (click)="getFeesHistory()">
                          <span class="material-icons">history</span> View History
                        </button>
                        <button type="submit" class="btn btn-primary" style="width: 225px;"
                                [disabled]="isLoadingObtainedFees">
                          <span *ngIf="!isLoadingObtainedFees" class="material-icons">payments</span>
                          <span *ngIf="isLoadingObtainedFees" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                          {{ isLoadingObtainedFees ? 'Loading...' : 'Generate Fees' }}
                        </button>
                      </div>

                    </div>
                  </div>
                  <!-- <div class="col col-lg-4 col-md-4 col-sm-4" *ngIf="payOffQuestionsFlag">
                    <div class="question-section">
                      <div class="row">
                        <div class="col-lg-12">
                          <mat-label>a. What is the high amount for the last mortgage being paid off ?</mat-label>
                          <mat-form-field class="example-full-width">
                            <input matInput placeholder="" formControlName="consideration" type="number">
                            <mat-error
                              *ngIf="titleFeesForm.get('consideration')?.invalid && titleFeesForm.get('consideration')?.touched">
                              {{ getErrorMessage(titleFeesForm.get('consideration')) }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-lg-12 mb-4">
                          <mat-label>b. What is the date of the last mortgage ?</mat-label>
                          <input matInput type="datetime-local" formControlName="policyDate"
                            class="custom-date-time-picker">
                          <mat-error
                            *ngIf="titleFeesForm.get('policyDate')?.invalid && titleFeesForm.get('policyDate')?.touched">{{getErrorMessage(titleFeesForm.get('policyDate'))}}</mat-error>
                        </div>
                        <div class="col-lg-12">
                          <mat-label>c. What is the current balance of pay off the mortgage ?</mat-label>
                          <mat-form-field class="example-full-width">
                            <input matInput placeholder="" formControlName="amount" type="number">
                            <mat-error
                              *ngIf="titleFeesForm.get('amount')?.invalid && titleFeesForm.get('amount')?.touched">
                              {{ getErrorMessage(titleFeesForm.get('amount')) }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col col-lg-4 col-md-4 col-sm-6" *ngIf="policyQuetionsFlag">
                    <div class="question-section">
                      <div class="row">
                        <div class="col-lg-12 mb-4">
                          <mat-label>a. Prior Policy Date</mat-label>
                          <input matInput type="datetime-local" formControlName="policyDate"
                            class="custom-date-time-picker">
                          <mat-error
                            *ngIf="titleFeesForm.get('policyDate')?.invalid && titleFeesForm.get('policyDate')?.touched">{{getErrorMessage(titleFeesForm.get('policyDate'))}}</mat-error>
                        </div>
                        <div class="col-lg-12">
                          <mat-label>b. Prior Policy Coverage Amount</mat-label>
                          <mat-form-field class="example-full-width">
                            <input matInput placeholder="" formControlName="consideration" type="number">
                            <mat-error
                              *ngIf="titleFeesForm.get('consideration')?.invalid && titleFeesForm.get('consideration')?.touched">
                              {{ getErrorMessage(titleFeesForm.get('consideration')) }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>



              </div>
            </div>

          </div>

          <div class="col col-md-7 mb-3">
            <div class="card-header">Title Fees Endorsement</div>
            <div class="card-body p-0">
              <div class="row">
                <div class="col col-lg-12 col-md-12 col-sm-12 p-0">
                  <div class="">
                    <table class="table table-bordered dashboard-transaction-table"
                           style="border-top: 1px solid darkgray;">
                      <!-- <thead><tr><th colspan="2">Endorsement</th></tr></thead> -->
                      <tbody>
                        <tr *ngFor="let item of endorsements">
                          <td width="35">
                            <mat-checkbox [(ngModel)]="item.isSelected"
                                          [ngModelOptions]="{standalone: true}"></mat-checkbox>
                          </td>
                          <td>{{ item.name }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col col-md-5 mb-3">
            <div class="card-header">Reissue Rates ?</div>
            <div class="card-body p-0">
              <div class="row">
                <div class="col col-lg-12 col-md-12 col-sm-12 p-0" *ngIf="payOffQuestionsFlag">
                  <div class="question-section">
                    <div class="row">
                      <div class="col-lg-12">
                        <mat-label>a. What is the high amount for the last mortgage being paid off ?</mat-label>
                        <mat-form-field class="example-full-width">
                          <span matPrefix>$</span>
                          <input matInput placeholder="" formControlName="consideration" type="number">
                          <mat-error *ngIf="titleFeesForm.get('consideration')?.invalid && titleFeesForm.get('consideration')?.touched">
                            {{ getErrorMessage(titleFeesForm.get('consideration')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-lg-12 mb-4">
                        <mat-label>b. What is the date of the last mortgage ?</mat-label>
                        <input matInput type="datetime-local" formControlName="policyDate"
                               class="custom-date-time-picker">
                        <mat-error *ngIf="titleFeesForm.get('policyDate')?.invalid && titleFeesForm.get('policyDate')?.touched">{{getErrorMessage(titleFeesForm.get('policyDate'))}}</mat-error>
                      </div>
                      <div class="col-lg-12">
                        <mat-label>c. What is the current balance of pay off the mortgage ?</mat-label>
                        <mat-form-field class="example-full-width">
                          <span matPrefix>$</span>
                          <input matInput placeholder="" formControlName="amount" type="number">
                          <mat-error *ngIf="titleFeesForm.get('amount')?.invalid && titleFeesForm.get('amount')?.touched">
                            {{ getErrorMessage(titleFeesForm.get('amount')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-lg-12 col-md-12 col-sm-12 p-0" *ngIf="policyQuetionsFlag">
                  <div class="question-section">
                    <div class="row">
                      <div class="col-lg-12 mb-4">
                        <mat-label>a. Prior Policy Date</mat-label>
                        <input matInput type="datetime-local" formControlName="policyDate"
                               class="custom-date-time-picker">
                        <mat-error *ngIf="titleFeesForm.get('policyDate')?.invalid && titleFeesForm.get('policyDate')?.touched">{{getErrorMessage(titleFeesForm.get('policyDate'))}}</mat-error>
                      </div>
                      <div class="col-lg-12">
                        <mat-label>b. Prior Policy Coverage Amount</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="consideration" type="number">
                          <mat-error *ngIf="titleFeesForm.get('consideration')?.invalid && titleFeesForm.get('consideration')?.touched">
                            {{ getErrorMessage(titleFeesForm.get('consideration')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #testTabTemplate>
    <div class="row justify-content-md-center">
      <div class="col-md-12">

        <div class="">
          <div class="card-header">Send To Unisource</div>
          <div class="card-body px-0">

            <div class="row">
              <div class="col col-lg-12 col-md-12 col-sm-12 px-0">
                <div class="table-container table-bordered" style="min-height: 250px; max-height: 300px">
                  <table class="table">
                    <thead>
                      <tr>
                        <th width="35">
                          <mat-checkbox [checked]="isAllSelectedUploadDocuments()"
                                        [indeterminate]="isIndeterminateUploadDocuments()"
                                        (change)="toggleSelectAllUploadDocuments($event)">
                          </mat-checkbox>
                        </th>
                        <th>Document Name</th>
                        <th>Type</th>
                        <th>Upload Date</th>
                        <th>uploaded By</th>
                        <th width="100" class="text-center">Status</th>
                      </tr>
                    </thead>
                    <tbody class="border-0">
                      <tr *ngIf="_uploadDocuments.length === 0">
                        <td colspan="8" class="no-field-added-row" style="border: 1px solid transparent;">
                          No record
                          found
                        </td>
                      </tr>
                      <tr class="border" *ngFor="let document of _uploadDocuments">
                        <td width="35">
                          <mat-checkbox [(ngModel)]="document.isSelected" [disabled]="document?.isDisabled"
                                        [ngModelOptions]="{standalone: true}">
                          </mat-checkbox>

                        </td>
                        <td>{{document?.name}}</td>
                        <td>{{document?.mimeType}}</td>
                        <td>{{document?.uploadDate | date: 'short'}}</td>
                        <td>{{document?.uploadedBy}}</td>
                        <td class="text-center">
                          <span *ngIf="document.status === uploadDocumentsStatus.Completed" title="{{document.status}}"
                                class="material-icons m-t-complete-check">check_circle</span>
                          <span *ngIf="document.status === uploadDocumentsStatus.Failed" title="{{document.status}}"
                                class="material-icons m-t-error-check">add_circle</span>
                          <span *ngIf="document.status === uploadDocumentsStatus.Pending" title="{{document.status}}"
                                class="material-icons skipped-icon">error_outline</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col col-lg-6 col-md-6 col-sm-6">

              </div>
              <div class="col col-lg-6 col-md-6 col-sm-6 mt-3">
                <div class="d-flex flex-row-reverse">
                  <div class="mt-4">
                    <!--<button type="button" class="btn btn-primary mr-3" (click)="selectDocuments()"><span class="material-icons">select_all</span> Select Documents</button>-->
                    <button type="button" class="btn btn-primary"
                            [disabled]="isDocumentLoading || _uploadDocuments.length === 0" (click)="uploadDocuments()"
                            style="width: 195px;">
                      <span *ngIf="!isDocumentLoading" class="material-icons">upload</span>
                      <span *ngIf="isDocumentLoading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                      {{ isDocumentLoading ? 'Loading...' : 'Send to Title Company' }}
                    </button>
                  </div>
                  <div class="mr-3">
                    <mat-label>Attach eFolder / System Doc(s)</mat-label>
                    <button type="button" class="btn btn-primary browse-button w-100" (click)="selectDocuments()">
                      <span class="material-icons">attach_file</span> Browse ...
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </ng-template>
  <ng-template #test1TabTemplate>
    <div class="row justify-content-md-center">
      <div class="col-md-12">

        <div class="">
          <div class="card-header">Download To efolder</div>
          <div class="card-body px-0">

            <div class="row">
              <div class="col col-lg-12 col-md-12 col-sm-12 px-0">
                <div class="table-container table-bordered" style="min-height: 250px; max-height: 300px">
                  <table class="table dashboard-transaction-table">
                    <thead>
                      <tr>
                        <th width="50">
                          <mat-checkbox [checked]="isAllSelectedDownloadDocuments()"
                                        [indeterminate]="isIndeterminateDownloadDocuments()"
                                        (change)="toggleSelectAllDownloadDocuments($event)">
                          </mat-checkbox>
                        </th>
                        <th>Document Name</th>
                        <th>Document Type</th>
                        <th>Upload Date</th>
                        <th>uploaded By</th>
                        <th width="100" class="text-center">Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody class="border-0">
                      <tr *ngIf="_documents.length === 0">
                        <td colspan="6" class="no-field-added-row" style="border: 1px solid transparent;">
                          No record
                          found
                        </td>
                      </tr>
                      <tr class="border" *ngFor="let document of _documents">
                        <td width="35">
                          <mat-checkbox [(ngModel)]="document.isSelected" [disabled]="document?.isDisabled"
                                        [ngModelOptions]="{standalone: true}">
                          </mat-checkbox>
                        </td>
                        <td>{{document?.name}}</td>
                        <td>{{document?.type}}</td>
                        <td>{{document?.uploadDate | date: 'short'}}</td>
                        <td>{{document?.uploadedBy}}</td>
                        <td class="text-center">
                          <span *ngIf="document.status === uploadDocumentsStatus.Completed" title="{{document.status}}"
                                class="material-icons m-t-complete-check">check_circle</span>
                          <span *ngIf="document.status === uploadDocumentsStatus.Failed" title="{{document.status}}"
                                class="material-icons m-t-error-check">add_circle</span>
                          <span *ngIf="document.status === uploadDocumentsStatus.Pending" title="{{document.status}}"
                                class="material-icons skipped-icon">error_outline</span>
                        </td>
                        <td>
                          <span *ngIf="!document?.uploadDate; else displayModeTemplate" title="Pending" class="material-icons skipped-icon">error_outline</span>
                          <ng-template #displayModeTemplate>
                            <span *ngIf="document.isAutomated" title="Auto Upload" class="material-icons skipped-icon">brightness_auto</span>
                            <span *ngIf="!document.isAutomated" title="Manual Upload" class="material-icons skipped-icon">person</span>
                          </ng-template>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col col-lg-12 col-md-12 col-sm-12 mt-3">
                <button type="button" class="btn btn-primary" *ngIf="isRetrieveDocumentsBtnDisplay"
                        [disabled]="isRetriveDocumentsLoading || _orders.length ===0" (click)="retrieveDocuments()"
                        style="width: 180px;">
                  <span *ngIf="!isRetriveDocumentsLoading" class="material-icons">article</span>
                  <span *ngIf="isRetriveDocumentsLoading" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                  {{ isRetriveDocumentsLoading ? 'Loading...' : 'Retrieve Documents' }}
                </button>
                <button type="button" class="btn btn-primary float-right"
                        [disabled]="isDocumentLoading || _documents.length === 0" (click)="uploadDocumentsToEfolder()"
                        style="width: 180px;">
                  <span *ngIf="!isDocumentLoading" class="material-icons">download</span>
                  <span *ngIf="isDocumentLoading" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                  {{ isDocumentLoading ? 'Loading...' : 'Send to eFolder' }}
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </ng-template>
  <ng-template #test2TabTemplate>
    <form class="example-form" [formGroup]="payoffsForm" (ngSubmit)="onPayOffsFormSubmit()">
      <div class="form-content">
        <div class="row justify-content-md-center">
          <div class="col-md-12">

            <div class="">
              <div class="card-header">Payoffs</div>
              <div class="card-body">

                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-8">
                    <div class="row">
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Borrower's last four social</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="****" formControlName="borrowerLastFourSocial" maxlength="4" pattern="[0-9]*" inputmode="numeric" />
                          <mat-error *ngIf="payoffsForm.get('borrowerLastFourSocial')?.errors?.['pattern'] && payoffsForm.get('borrowerLastFourSocial')?.touched">
                            Must
                            be exactly 4 digits.
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Lender's Name</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="lenderName">
                          <mat-error *ngIf="payoffsForm.get('lenderName')?.invalid && payoffsForm.get('lenderName')?.touched">
                            {{ getErrorMessage(payoffsForm.get('lenderName')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Liabilty Type</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="liabilityType">
                            <mat-option *ngFor="let option of liabilityTypeList" [value]="option.value">
                              {{
 option.value
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="payoffsForm.get('liabilityType')?.invalid && payoffsForm.get('liabilityType')?.touched">
                            {{getErrorMessage(payoffsForm.get('liabilityType'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Payoff Information</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="payoffInformation">
                            <mat-option *ngFor="let option of payoffInformationList" [value]="option.value">
                              {{
                              option.value
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="payoffsForm.get('payoffInformation')?.invalid && payoffsForm.get('payoffInformation')?.touched">
                            {{getErrorMessage(payoffsForm.get('payoffInformation'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Lien Priority</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="lienPriority">
                            <mat-option *ngFor="let option of lienPriorityList" [value]="option.value">
                              {{
 option.value
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="payoffsForm.get('lienPriority')?.invalid && payoffsForm.get('lienPriority')?.touched">
                            {{getErrorMessage(payoffsForm.get('lienPriority'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Team</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="team">
                            <mat-option *ngFor="let option of teamsList" [value]="option.value">
                              {{
 option.value
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="payoffsForm.get('team')?.invalid && payoffsForm.get('team')?.touched">
                            {{getErrorMessage(payoffsForm.get('team'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Attach eFolder / System Doc(s)</mat-label>
                        <button type="button" class="btn btn-primary browse-button w-100"
                                (click)="browsePayOffsDocuments()">
                          <span class="material-icons">attach_file</span> Browse
                          ...
                        </button>
                      </div>
                      <div class="col-lg-12 mt-3">
                        <div class="table-container">
                          <table class="table table-bordered browse-attachment-tbl">
                            <thead>
                              <tr>
                                <th width="35"></th>
                                <th>Attachment Name</th>
                                <th>Source</th>
                                <th>Folder</th>
                                <th>Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngIf="_payOffsAttachments.length === 0">
                                <td colspan="5" class="no-field-added-row">No record found</td>
                              </tr>
                              <tr *ngFor="let document of _payOffsAttachments">
                                <td width="35">
                                  <mat-checkbox [(ngModel)]="document.isSelected"
                                                [ngModelOptions]="{standalone: true}"></mat-checkbox>
                                </td>
                                <td>{{document?.name}}</td>
                                <td>{{document?.source}}</td>
                                <td>{{document?.documentFolder}}</td>
                                <td>{{document?.mimeType}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Comments</mat-label>
                    <mat-form-field class="example-full-width">
                      <textarea matInput formControlName="comments" rows="7"></textarea>
                      <mat-error *ngIf="payoffsForm.get('comments')?.invalid && payoffsForm.get('comments')?.touched">
                        {{ getErrorMessage(payoffsForm.get('comments')) }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                </div>

                <div class="row">
                  <div class="col col-lg-4 col-md-4 col-sm-4">
                    <button type="submit" class="btn btn-primary w-100 mt-3"
                            [disabled]="isFormSubmitLoading || _orders.length ===0">
                      <span *ngIf="!isFormSubmitLoading" class="material-icons">send</span>
                      <span *ngIf="isFormSubmitLoading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                      {{ isFormSubmitLoading ? 'Loading...' : 'Submit Payoff Request' }}
                    </button>
                  </div>
                </div>


              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #test3TabTemplate>
    <form class="example-form" [formGroup]="verificationsForm" (ngSubmit)="onVerificationFormSubmit()">
      <div class="form-content">
        <div class="row justify-content-md-center">
          <div class="col-md-12">

            <div class="">
              <div class="card-header">Verifications</div>
              <div class="card-body">

                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-8">
                    <div class="row">
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-checkbox formControlName="isInsuranceVerification"
                                      class="mat-check-position-top mb-4">Verify Homeowner's Insurance</mat-checkbox>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-checkbox formControlName="isAsssociateVerification"
                                      class="mat-check-position-top mb-4">Verify Homeowner's Association</mat-checkbox>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Company Name</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="companyName">
                          <mat-error *ngIf="verificationsForm.get('companyName')?.invalid && verificationsForm.get('companyName')?.touched">
                            {{ getErrorMessage(verificationsForm.get('companyName')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Association Name</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="associateName">
                          <mat-error *ngIf="verificationsForm.get('associateName')?.invalid && verificationsForm.get('associateName')?.touched">
                            {{ getErrorMessage(verificationsForm.get('associateName')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Phone Number</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="companyPhone">
                          <mat-error *ngIf="verificationsForm.get('companyPhone')?.invalid && verificationsForm.get('companyPhone')?.touched">
                            {{ getErrorMessage(verificationsForm.get('companyPhone')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Phone Number</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="associatePhone">
                          <mat-error *ngIf="verificationsForm.get('associatePhone')?.invalid && verificationsForm.get('associatePhone')?.touched">
                            {{ getErrorMessage(verificationsForm.get('associatePhone')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Account Number</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="companyAccountNumber">
                          <mat-error *ngIf="verificationsForm.get('companyAccountNumber')?.invalid && verificationsForm.get('companyAccountNumber')?.touched">
                            {{ getErrorMessage(verificationsForm.get('companyAccountNumber')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Account Number</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="associateAccountNumber">
                          <mat-error *ngIf="verificationsForm.get('associateAccountNumber')?.invalid && verificationsForm.get('associateAccountNumber')?.touched">
                            {{ getErrorMessage(verificationsForm.get('associateAccountNumber')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Team</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="team">
                            <mat-option *ngFor="let option of teamsList" [value]="option.value">
                              {{
 option.value
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="verificationsForm.get('team')?.invalid && verificationsForm.get('team')?.touched">
                            {{getErrorMessage(verificationsForm.get('team'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Attach eFolder / System Doc(s)</mat-label>
                        <button type="button" class="btn btn-primary browse-button w-100"
                                (click)="browseVerificationDocuments()">
                          <span class="material-icons">attach_file</span> Browse
                          ...
                        </button>
                      </div>
                      <div class="col col-lg-12 col-md-12 col-sm-12">
                        <div class="table-container">
                          <table class="table table-bordered browse-attachment-tbl">
                            <thead>
                              <tr>
                                <th width="35"></th>
                                <th>Attachment Name</th>
                                <th>Source</th>
                                <th>Folder</th>
                                <th>Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngIf="_verificationAttachments.length === 0">
                                <td colspan="5" class="no-field-added-row">No record found</td>
                              </tr>
                              <tr *ngFor="let document of _verificationAttachments">
                                <td width="35">
                                  <mat-checkbox [(ngModel)]="document.isSelected"
                                                [ngModelOptions]="{standalone: true}"></mat-checkbox>
                                </td>
                                <td>{{document?.name}}</td>
                                <td>{{document?.source}}</td>
                                <td>{{document?.documentFolder}}</td>
                                <td>{{document?.mimeType}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Comments</mat-label>
                    <mat-form-field class="example-full-width">
                      <textarea matInput formControlName="comments" rows="8"></textarea>
                      <mat-error *ngIf="verificationsForm.get('comments')?.invalid && verificationsForm.get('comments')?.touched">
                        {{ getErrorMessage(verificationsForm.get('comments')) }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col col-lg-4 col-md-4 col-sm-4">
                    <button type="submit" class="btn btn-primary w-100 mt-3"
                            [disabled]="isFormSubmitLoading || _orders.length ===0">
                      <span *ngIf="!isFormSubmitLoading" class="material-icons">send</span>
                      <span *ngIf="isFormSubmitLoading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                      {{ isFormSubmitLoading ? 'Loading...' : 'Submit Verifications' }}
                    </button>
                  </div>
                </div>


              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #test4TabTemplate>
    <form class="example-form" [formGroup]="schedulerForm" (ngSubmit)="onScheduleFormSubmit()">
      <div class="form-content">
        <div class="row justify-content-md-center">
          <div class="col-md-12">

            <div class="">
              <div class="card-header">Schedule Mobile Notary</div>
              <div class="card-body">

                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-8">
                    <div class="row">
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Borrower Address</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="borrowerAddress">
                          <mat-error *ngIf="schedulerForm.get('borrowerAddress')?.invalid && schedulerForm.get('borrowerAddress')?.touched">
                            {{ getErrorMessage(schedulerForm.get('borrowerAddress')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Requested Date Time</mat-label>
                        <input matInput type="datetime-local" formControlName="requestedDateTime"
                               class="custom-date-time-picker">
                        <mat-error *ngIf="schedulerForm.get('requestedDateTime')?.invalid && schedulerForm.get('requestedDateTime')?.touched">{{getErrorMessage(schedulerForm.get('requestedDateTime'))}}</mat-error>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Phone Number</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="phone">
                          <mat-error *ngIf="schedulerForm.get('phone')?.invalid && schedulerForm.get('phone')?.touched">
                            {{ getErrorMessage(schedulerForm.get('phone')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Cell Phone Number</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="cellPhone">
                          <mat-error *ngIf="schedulerForm.get('cellPhone')?.invalid && schedulerForm.get('cellPhone')?.touched">
                            {{ getErrorMessage(schedulerForm.get('cellPhone')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Work Phone Number</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="" formControlName="workPhone">
                          <mat-error *ngIf="schedulerForm.get('workPhone')?.invalid && schedulerForm.get('workPhone')?.touched">
                            {{ getErrorMessage(schedulerForm.get('workPhone')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <mat-label>Team</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="team">
                            <mat-option *ngFor="let option of teamsList" [value]="option.value">
                              {{
 option.value
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="schedulerForm.get('team')?.invalid && schedulerForm.get('team')?.touched">
                            {{ getErrorMessage(schedulerForm.get('team')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col col-lg-6 col-md-6 col-sm-6">
                        <div>
                          <mat-checkbox formControlName="isBorrowerAddress"
                                        (change)="onBorrowerAddressCheckboxChange($event)"
                                        class="mat-check-position-top mb-4">Borrower Address</mat-checkbox>
                        </div>
                        <mat-label>Location</mat-label>
                        <mat-form-field class="example-full-width">
                          <textarea matInput formControlName="location" rows="3"></textarea>
                          <mat-error *ngIf="schedulerForm.get('location')?.invalid && schedulerForm.get('location')?.touched">
                            {{ getErrorMessage(schedulerForm.get('location')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Comments</mat-label>
                    <mat-form-field class="example-full-width">
                      <textarea matInput formControlName="comments" rows="7"></textarea>
                      <mat-error *ngIf="schedulerForm.get('comments')?.invalid && schedulerForm.get('comments')?.touched">
                        {{ getErrorMessage(schedulerForm.get('comments')) }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col col-lg-4 col-md-4 col-sm-4">
                    <button type="submit" class="btn btn-primary w-100 mt-3"
                            [disabled]="isFormSubmitLoading || _orders.length ===0">
                      <span *ngIf="!isFormSubmitLoading" class="material-icons">send</span>
                      <span *ngIf="isFormSubmitLoading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                      {{ isFormSubmitLoading ? 'Loading...' : 'Schedule Appointment' }}
                    </button>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #test5TabTemplate>
    <form class="example-form" [formGroup]="emailForm" (ngSubmit)="onEmailFormSubmit()">
      <div class="form-content">
        <div class="row justify-content-md-center">
          <div class="col-md-12">

            <div class="">
              <div class="card-header">Email Your Team</div>
              <div class="card-body">

                <div class="row">
                  <div class="col-lg-7 col-md-7 col-sm-7">

                    <div class="row">
                      <div class="col col-lg-10 col-md-10 col-sm-10"
                           style="max-width: calc(100% - 210px); min-width: calc(100% - 210px); ">
                        <mat-label>Team</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select formControlName="team">
                            <mat-option *ngFor="let option of teamsList" [value]="option.value">
                              {{
 option.value
                              }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="emailForm.get('team')?.invalid && emailForm.get('team')?.touched">
                            {{getErrorMessage(emailForm.get('team'))}}
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col col-lg-2 col-md-2 col-sm-2" style="min-width: 210px; max-width: 210px; ">
                        <mat-label>Attach eFolder / System Doc(s)</mat-label>
                        <button type="button" class="btn btn-primary browse-button w-100"
                                (click)="browseEmailDocuments()">
                          <span class="material-icons">attach_file</span> Browse
                          ...
                        </button>
                      </div>
                      <div class="col col-lg-12 col-md-12 col-sm-12">
                        <div class="table-container">
                          <table class="table table-bordered browse-attachment-tbl">
                            <thead>
                              <tr>
                                <th width="35"></th>
                                <th>Attachment Name</th>
                                <th>Source</th>
                                <th>Folder</th>
                                <th>Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngIf="_emailAttachments.length === 0">
                                <td colspan="5" class="no-field-added-row">No record found</td>
                              </tr>
                              <tr *ngFor="let document of _emailAttachments">
                                <td width="35">
                                  <mat-checkbox [(ngModel)]="document.isSelected"
                                                [ngModelOptions]="{standalone: true}"></mat-checkbox>
                                </td>
                                <td>{{document?.name}}</td>
                                <td>{{document?.source}}</td>
                                <td>{{document?.documentFolder}}</td>
                                <td>{{document?.mimeType}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="col col-lg-8 col-md-8 col-sm-8">
                        <button type="submit" class="btn btn-primary w-100 mt-3"
                                [disabled]="isFormSubmitLoading || _orders.length ===0">
                          <span *ngIf="!isFormSubmitLoading" class="material-icons">send</span>
                          <span *ngIf="isFormSubmitLoading" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                          {{ isFormSubmitLoading ? 'Loading...' : 'Send to Team' }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-5 col-sm-5">
                    <div class="row">
                      <div class="col col-lg-12 col-md-12 col-sm-12">
                        <mat-label>Comments</mat-label>
                        <mat-form-field class="example-full-width">
                          <textarea matInput formControlName="comments" rows="6"></textarea>
                          <mat-error *ngIf="emailForm.get('comments')?.invalid && emailForm.get('comments')?.touched">
                            {{ getErrorMessage(emailForm.get('comments')) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                </div>


              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
  </ng-template>


</div>



<div class="modal fade" id="feesDetailModal" aria-modal="false">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 1000px">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Title Fees</h4>
        <button type="button" class="btn btn-light btn-circle" (click)="confirmationImportFeesDialogCancel()">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="modal-body" style="height: 500px">

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <p class="mb-2">Select the title fees you want to import.</p>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="table-container" style="min-height: 324px; max-height: 324px;">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th width="50"></th>
                    <th>Line #</th>
                    <th>Fee Description</th>
                    <th>Amount</th>
                    <th width="100">APR Affecting Fee</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="feesList.length === 0">
                    <td colspan="5" class="no-field-added-row">No record found</td>
                  </tr>
                  <tr *ngFor="let item of feesList; let i = index">
                    <td width="35">
                      <mat-checkbox [(ngModel)]="item.isSelected"
                                    [ngModelOptions]="{standalone: true}"></mat-checkbox>
                    </td>
                    <td>{{item.lineNumber}}</td>
                    <td>{{item.description}}</td>
                    <td>${{ item.amount | number: '1.2-2' }}</td>
                    <td class="text-center">
                      <mat-checkbox checked="{{item.aprAffectingFee}}"
                                    [disabled]="true"></mat-checkbox>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-2">
            <p class="obt-fees-total">Total: ${{ totalFeesAmount | number: '1.2-2' }}</p>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <p class="obt-fees-desc-text">
              <span>
                The estimate provided above reflects the total fees based on assumptions with regards to documents
                required for recording and the recording jurisdiction for the supplied state and country. In addition, a
                limited set of endorsements are quoted; if additional endorsements are needed, please contact us.
              </span>
              <br />
              <br />
              <span>
                While every effort has been made to ensure that these sales are correct, amounts may change based on
                dates, prior loan amounts, rate changes from underwriters and accuracy of input. These rates will supply
                an estimate, but are not guaranteed until transaction is finalized.
              </span>
            </p>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-primary mr-2" (click)="confirmationFees()"><span
            class="material-icons">upload</span> Import</button> -->
        <button type="button" class="btn btn-primary mr-2" [disabled]="isFeesImportForStatus"
                (click)="confirmationFees()">
          <span *ngIf="!isFeesImportForStatus" class="material-icons">download</span>
          <span *ngIf="isFeesImportForStatus" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>
          {{ isFeesImportForStatus ? 'Loading...' : 'Import' }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="confirmationImportFeesDialogCancel()">
          <span class="material-icons">close</span> Close
        </button>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="loadingProcessDetailModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 500px">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">
          {{ processingStatusDetail.IsFeesImport ? 'Fees Import Status' : 'Order Submit Status' }}
        </h4>
        <!--<button type="button" class="btn btn-light btn-circle" (click)="hideLoadingProcessDetailModal()"><span class="material-icons">close</span></button>-->
      </div>
      <div class="modal-body" style="">

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="sync-list">
              <p class="text-center">The task is being executed. Please wait until it is completed.</p>
              <div class="sync-card">
                <div class="sync-left">
                  <span class="check-icon">
                    <i class="material-icons">check_circle</i>
                  </span>
                  <span class="sync-title">Initiating</span>
                </div>
                <div class="sync-status">Completed.</div>
              </div>

              <div *ngIf="!processingStatusDetail.IsFeesImport" class="sync-card">
                <div class="sync-left">
                  <span class="check-icon">
                    <i class="material-icons">check_circle</i>
                  </span>
                  <span class="sync-title">Processing</span>
                </div>
                <div class="sync-status">Completed.</div>
              </div>

              <div *ngIf="processingStatusDetail.IsFeesImport" class="sync-card">
                <div class="sync-left">
                  <span class="check-icon">
                    <span *ngIf="!processingStatusDetail.Completed && !processingStatusDetail.Failed && !processingStatusDetail.Canceled; else feesImportingStatusElse"
                          class="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>
                    <ng-template #feesImportingStatusElse>
                      <i class="material-icons">check_circle</i>
                    </ng-template>
                  </span>
                  <span class="sync-title">Fees Importing...</span>
                </div>
                <div class="sync-status">{{ processingStatusDetail.Completed ? 'Completed.' : '' }}</div>
              </div>

              <div *ngIf="!processingStatusDetail.IsFeesImport" class="sync-card">
                <div class="sync-left">
                  <span class="check-icon">
                    <ng-container *ngIf="!processingStatusDetail.OrderSubmited && !processingStatusDetail.Completed && !processingStatusDetail.Failed; else submittedStatusElse">
                      <span class="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>
                    </ng-container>

                    <ng-template #submittedStatusElse>
                      <ng-container *ngIf="processingStatusDetail.Failed || processingStatusDetail.Canceled; else submittedStatusNestedElse">
                        <i class="material-icons text-danger success-icon">cancel</i>
                      </ng-container>

                      <ng-template #submittedStatusNestedElse>
                        <i class="material-icons">check_circle</i>
                      </ng-template>
                    </ng-template>
                  </span>
                  <span class="sync-title">
                    Order Submitted <b *ngIf="transactionStatus && transactionStatus.orderNumber.trim() !== ''">#{{transactionStatus.orderNumber}}</b>
                  </span>
                </div>
                <div class="sync-status">
                  {{
 (processingStatusDetail.OrderSubmited || processingStatusDetail.Completed) ?
                  'Completed.' : ''
                  }}
                </div>
              </div>

              <div *ngIf="processingStatusDetail.UpdatingLoan" class="sync-card">
                <div class="sync-left">
                  <span class="check-icon">
                    <span *ngIf="!processingStatusDetail.UpdatingLoan && !isProcessStatusSkip"
                          class="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>
                    <i *ngIf="processingStatusDetail.UpdatingLoan" class="material-icons">check_circle</i>
                    <i *ngIf="isProcessStatusSkip && !processingStatusDetail.UpdatingLoan"
                       class="material-icons skipped-icon">remove_circle</i>
                  </span>
                  <span class="sync-title">Loan Updating</span>
                </div>
                <div class="sync-status">
                  <ng-container *ngIf="processingStatusDetail.UpdatingLoan; else skipped">
                    Completed.
                  </ng-container>
                  <ng-template #skipped>
                    <span *ngIf="isProcessStatusSkip">Skipped.</span>
                  </ng-template>
                </div>
              </div>
              <div class="sync-card">
                <div class="sync-left">
                  <span class="check-icon">
                    <span *ngIf="!processingStatusDetail.Completed && !processingStatusDetail.Failed && !processingStatusDetail.Canceled"
                          class="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>
                    <i *ngIf="processingStatusDetail.Completed" class="material-icons">check_circle</i>
                    <span *ngIf="!processingStatusDetail.Completed && (processingStatusDetail.Failed || processingStatusDetail.Canceled)"
                          class="material-icons text-danger success-icon">cancel</span>
                  </span>
                  <span class="sync-title">
                    {{
 processingStatusDetail.Failed || processingStatusDetail.Canceled ?
                    'Failed.' : 'Completed'
                    }}
                  </span>
                </div>
                <div class="sync-status">
                  {{
 processingStatusDetail.Failed || processingStatusDetail.Canceled ? 'Failed.'
                  : ''
                  }}
                </div>
              </div>

              <p *ngIf="processingStatusDetail.Message.trim() !==''" class="process-status-error-text text-center">
                {{
                processingStatusDetail.Message
                }}
              </p>

              <button type="button" class="btn btn-primary w-100 mb-2 mt-3"
                      [disabled]="isProcessDoneLoading || !isProcessStop" (click)="onLoadingProcessDialogDoneButtonClick()"
                      style="padding: 6px; font-size: 1.1rem;">
                <span *ngIf="!isProcessDoneLoading" class="material-icons">check</span>
                <span *ngIf="isProcessDoneLoading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                {{ isProcessDoneLoading ? 'Loading...' : 'Done' }}
              </button>
            </div>


          </div>
        </div>

      </div>
      <!--<div class="modal-footer">

      </div>-->
    </div>
  </div>
</div>


<div class="modal fade" id="loadingDocumentProcessDetailModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 500px;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Documents Status</h4>
        <!--<button type="button" class="btn btn-light btn-circle" (click)="hideLoadingProcessDetailModal()"><span class="material-icons">close</span></button>-->
      </div>
      <div class="modal-body" style="max-height: 475px;">

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="sync-list">
              <p class="text-center">The task is being executed. Please wait until it is completed.</p>
              <div class="sync-card">
                <div class="sync-left">
                  <span class="check-icon">
                    <i class="material-icons">check_circle</i>
                  </span>
                  <span class="sync-title">Initiating</span>
                </div>
                <div class="sync-status">Completed.</div>
              </div>
              <div class="sync-card" *ngFor="let item of documentsResponseStatusList let i = index">
                <div class="sync-left">
                  <span class="check-icon">
                    <ng-container *ngIf="item.documentStatus === 'Completed'; else documentsSubmittingStatusElse">
                      <i class="material-icons">check_circle</i>
                    </ng-container>
                    <ng-template #documentsSubmittingStatusElse>
                      <ng-container *ngIf="item.documentStatus === 'Failed'; else documentsSubmittingStatusNestedElse">
                        <i class="material-icons text-danger success-icon">cancel</i>
                      </ng-container>
                      <ng-template #documentsSubmittingStatusNestedElse>
                        <span class="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>
                      </ng-template>
                    </ng-template>
                  </span>
                  <span class="sync-title">{{item.documentName}}</span>
                </div>
                <div class="sync-status" title="{{item.message}}">{{item.documentStatus}}.</div>
              </div>

              <!-- <p *ngIf="formStatus && formStatus.status === 'Failed' && formStatus.message.trim() !==''"
                class="process-status-error-text text-center">{{
                formStatus.message}}</p> -->

            </div>
          </div>

        </div>

      </div>
      <div class="modal-footer" style="padding: 5px 25px 15px; border: none;">
        <button type="button" class="btn btn-primary w-100" [disabled]="isProcessDoneLoading || isDocumentLoading"
                (click)="onLoadingDocumentsProcessDialogDoneButtonClick()" style="padding: 6px; font-size: 1.1rem;">
          <span *ngIf="!isProcessDoneLoading" class="material-icons">check</span>
          <span *ngIf="isProcessDoneLoading" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>
          {{ isProcessDoneLoading ? 'Loading...' : 'Done' }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="loadingFormsSubmitProcessDetailModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 500px;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Process Status</h4>
      </div>
      <div class="modal-body" style="max-height: 475px;">

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="sync-list">
              <p class="text-center">The task is being executed. Please wait until it is completed.</p>
              <div class="sync-card">
                <div class="sync-left">
                  <span class="check-icon">
                    <i class="material-icons">check_circle</i>
                  </span>
                  <span class="sync-title">Initiating</span>
                </div>
                <div class="sync-status">Completed.</div>
              </div>
              <div class="sync-card">
                <div class="sync-left">
                  <span class="check-icon">
                    <ng-container *ngIf="formStatus?.status === 'Completed'; else FormSubmittingStatusElse">
                      <i class="material-icons">check_circle</i>
                    </ng-container>
                    <ng-template #FormSubmittingStatusElse>
                      <ng-container *ngIf="formStatus?.status === 'Failed'; else FormSubmittingStatusNestedElse">
                        <i class="material-icons text-danger success-icon">cancel</i>
                      </ng-container>
                      <ng-template #FormSubmittingStatusNestedElse>
                        <span class="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>
                      </ng-template>
                    </ng-template>
                  </span>
                  <span class="sync-title" *ngIf="isFeesImportForStatus; else ForImportingFeesElse">Importing</span>
                  <ng-template #ForImportingFeesElse>
                    <span class="sync-title">Submitting</span>
                  </ng-template>
                </div>
                <div class="sync-status">{{formStatus?.status}}.</div>
              </div>
              <div class="sync-card">
                <div class="sync-left">
                  <span class="check-icon">
                    <ng-container *ngIf="formStatus?.status === 'Completed'; else FormCompletedStatusElse">
                      <i class="material-icons">check_circle</i>
                    </ng-container>
                    <ng-template #FormCompletedStatusElse>
                      <ng-container *ngIf="formStatus?.status === 'Failed'; else FormCompletedStatusNestedElse">
                        <i class="material-icons text-danger success-icon">cancel</i>
                      </ng-container>
                      <ng-template #FormCompletedStatusNestedElse>
                        <span class="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>
                      </ng-template>
                    </ng-template>
                  </span>
                  <span class="sync-title">Completed</span>
                </div>
                <div class="sync-status">{{formStatus?.status}}.</div>
              </div>

              <p *ngIf="formStatus && formStatus.status === 'Failed' && formStatus.message.trim() !==''"
                 class="process-status-error-text text-center">
                {{
                formStatus.message
                }}
              </p>

            </div>
          </div>

        </div>

      </div>
      <div class="modal-footer" style="padding: 5px 25px 15px; border: none;">
        <button type="button" class="btn btn-primary w-100" [disabled]="isProcessDoneLoading || formsPollingIntervalId"
                (click)="onLoadingFormSubmissionProcessDialogDoneButtonClick()" style="padding: 6px; font-size: 1.1rem;">
          <span *ngIf="!isProcessDoneLoading" class="material-icons">check</span>
          <span *ngIf="isProcessDoneLoading" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>
          {{ isProcessDoneLoading ? 'Loading...' : 'Done' }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="orderFeesStatusHistoryModal" aria-modal="false">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 1200px">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">History</h4>
        <button type="button" class="btn btn-light btn-circle" (click)="hideOrderFeesStatusHistoryModal()">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="modal-body background-color-light-gray" style="height: 500px">

        <div class="row mat-tbl-search-row">
          <div class="col-lg-12 col-md-12 col-sm-12 text-right">
            <div class="input-group">
              <div class="input-group-prepend ">
                <span class="input-group-text bg-white"><i class="material-icons f-16">search</i></span>
              </div>
              <input type="text" class="form-control border-left-0" (keyup)="applyFilter()" [(ngModel)]="searchText"
                     [ngModelOptions]="{standalone: true}" placeholder="Search...">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="table-container" style="min-height: 438px; max-height: 438px;">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Action</th>
                    <th>Transaction Id</th>
                    <th *ngIf="isViewOrderHistory">Order Status</th>
                    <th *ngIf="isViewOrderHistory">Order Number</th>
                    <!--<th>Loan Number</th>-->
                    <th>Loan Amount</th>
                    <th>Sales Price</th>
                    <th>Product Type</th>
                    <th>Transaction Type</th>
                    <th>Property Address</th>
                    <th>Requested By</th>
                    <th>Requested Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="filterdTransactionHistoryList.length === 0">
                    <td colspan="11" class="no-field-added-row">No record found</td>
                  </tr>
                  <tr *ngFor="let item of filterdTransactionHistoryList; let i = index">

                    <td class="text-center">
                      <span *ngIf="item?.status?.toLowerCase() === _transactionStatus.Completed" title="{{item?.status}}"
                            class="material-icons m-t-complete-check">check_circle</span>
                      <span *ngIf="item?.status?.toLowerCase() === _transactionStatus.Failed" title="{{item?.status}}"
                            class="material-icons m-t-error-check">add_circle</span>
                      <span *ngIf="item?.status?.toLowerCase() === _transactionStatus.Pending" title="{{item?.status}}"
                            class="material-icons skipped-icon">error_outline</span>
                      <span *ngIf="item?.status?.toLowerCase() === _transactionStatus.Cancelled" title="{{item?.status}}"
                            class="material-icons m-t-cancel-icon">error</span>
                      <span *ngIf="item?.status?.toLowerCase() === _transactionStatus.Processing" title="{{item?.status}}"
                            class="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>
                      <span *ngIf="!item?.status || item?.status === ''" title="{{item?.status}}"
                            class="material-icons skipped-icon">remove_circle</span>
                    </td>
                    <td class="text-center">
                      <span *ngIf="item?.isAutomated" title="Auto Order" class="material-icons skipped-icon">brightness_auto</span>
                      <span *ngIf="!item?.isAutomated" title="Manual Order" class="material-icons skipped-icon">person</span>
                    </td>
                    <td>{{item?.transactionId}}</td>
                    <td *ngIf="isViewOrderHistory">
                      <span class="custom-icon-widget i-w-error-check" *ngIf="item.reswareOrderStatus && (item?.reswareOrderStatus.toLowerCase() === 'closed' || item?.reswareOrderStatus.toLowerCase() === 'cancelled'); else raswareOrderStatusElse">{{item?.reswareOrderStatus}}</span>
                      <ng-template #raswareOrderStatusElse>
                        <span class="custom-icon-widget i-w-complete-check" *ngIf="item.reswareOrderStatus">{{item?.reswareOrderStatus}}</span>
                      </ng-template>
                    </td>
                    <td *ngIf="isViewOrderHistory">{{item?.orderNumber}}</td>
                    <!--<td>{{item?.loanNumber}}</td>-->
                    <td>{{item?.loanAmount | number: '1.2-2'}}</td>
                    <td>{{item?.salesPrice | number: '1.2-2'}}</td>
                    <td>{{item?.productType}}</td>
                    <td>{{item?.transactionType}}</td>
                    <td>{{item?.propertyAddress}}, {{item?.propertyCity}}, {{item?.propertyState}}, {{item?.propertyZip}}</td>
                    <td>{{item?.reswareUserName}}</td>
                    <td>{{item?.createdAt | date: 'short' }}</td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

      </div>
      <div class="modal-footer">

        <button type="button" class="btn btn-secondary" (click)="hideOrderFeesStatusHistoryModal()">
          <span class="material-icons">close</span> Close
        </button>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="transactionResponseAPIStatusModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 360px;">
    <div class="modal-content" style="padding: 8px 10px 2px;">
      <div class="modal-body">
        <h2 class="modal-title">Processing Request</h2>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <p class="mt-3">The EPC integration is taking longer than expected. <br>You may choose to wait or exit the transaction.</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="transactionNotRespondingWaitBtn()"><span class="material-icons">hourglass_top</span> Continue Waiting</button>
        <!-- <button type="button" class="btn btn-primary" (click)="onProcessDoneButtonClick()"><span class="material-icons">close</span> Exit</button> -->
        <button type="button" class="btn btn-secondary" [disabled]="isEPCNotRespondingLoading"
                (click)="onProcessDoneButtonClick()">
          <span *ngIf="!isEPCNotRespondingLoading" class="material-icons">close</span>
          <span *ngIf="isEPCNotRespondingLoading" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>
          {{ isEPCNotRespondingLoading ? 'Loading...' : 'Exit' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- REQUIRED FIELDS MODAL -->
<div class="modal fade" id="requiredFieldsModal" tabindex="-1" aria-labelledby="requiredFieldsLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered required-fields-modal" style="max-width: 390px;">
    <div class="modal-content" style="padding: 8px 10px 2px;">

      <div class="modal-body">
        <h2 class="modal-title" style="color: #014068">Required Fields</h2>
        <hr class="custom-hr" style="color: #dee2e6; margin-top: 13px;" />
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 pt-2 pb-3">
            <mat-label *ngFor="let field of missingFields">{{ field }} <span class="required-lable-txt">*</span><br /></mat-label>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-end">
        <button type="button" class="btn btn-primary" (click)="hideRequiredFieldsModal()">
          <span class="material-icons">close</span> Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- SESSION EXPIRED MODAL -->
<div class="modal fade" id="sessionExpiredModal" tabindex="-1" aria-labelledby="sessionExpiredLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 390px;">
    <div class="modal-content" style="padding: 8px 10px 2px;">

      <div class="modal-body">
        <h2 class="modal-title">Session Expired</h2>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <p class="mt-3">Your session will expire in <span id="countdownValue" class="text-dark">60</span> seconds. Do you want to reset it ?</p>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-end">
        <button type="button" class="btn btn-secondary" [disabled]="isEPCNotRespondingLoading" (click)="onProcessDoneButtonClick()">
          <span *ngIf="!isEPCNotRespondingLoading" class="material-icons">close</span>
          <span *ngIf="isEPCNotRespondingLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ isEPCNotRespondingLoading ? 'Loading...' : 'No' }}
        </button>
        <button type="button" class="btn btn-primary" style="width: 108px" [disabled]="isSessionResetLoading" (click)="resetApp()">
          <span *ngIf="!isSessionResetLoading" class="material-icons">restore</span>
          <span *ngIf="isSessionResetLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ isSessionResetLoading ? 'Loading...' : 'Reset' }}
        </button>
      </div>
    </div>
  </div>
</div>
